const selectors = [...document.querySelectorAll('.js-project-category-selector')];


selectors.forEach((selector) => {
    selector.addEventListener('change', (event) => {
        window.location = `${window.location.origin}/projects/category/${event.target.value}`;
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/projectCategorySelector.js